import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts } from '../../../settings';
import { DelayLink } from '../../../components';

import './Card5.scss';

class Card5 extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Grupos consultivos passam por reformulação - Iniciativas - {texts.title}</title>
        </Helmet>

        <div className="iniciativas-home card5-home page-gradient page-gradient--yellow bg-gray" ref="card5-home">
          <section className="iniciativas-area card5-area page--yellow">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink
                            to="/estrategias/para-o-mercado"
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title">Grupos consultivos passam por reformulação</h1>
                        </div>
                        <div className="card__content__body">
                          <div className="row flex">
                            <div className="col-12">
                              <p>
                                Iniciado em 2019, o redesenho da nossa governança de representação consolidou-se ainda
                                mais em 2020, ano que focamos na reorganização dos grupos consultivos. Esses grupos
                                respondem à Diretoria e são divididos em duas categorias: os grupos consultivos
                                permanentes dão suporte aos produtos e serviços que oferecemos, além de traçarem
                                cenários e projeções para o mercado; enquanto os grupos consultivos para temas
                                emergentes discutem assuntos transversais que não estão 100% incorporados à pauta
                                específica dos fóruns. Desde 2019, temos três grupos para temas emergentes. Acompanhe os
                                principais avanços deles em 2020:
                              </p>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-4">
                              <p>
                                <img src={images.iniciativas.card5.img1} />
                                <br />
                                <b className="yellow">Sustentabilidade</b>
                                <br />
                                Ganhou novos membros e uma nova liderança. Para ampliar a discussão sobre
                                sustentabilidade, passaram a fazer parte do grupo companhias emissoras de papéis
                                sustentáveis (sell side), além das gestoras de recursos (buy side). Veja mais, em{' '}
                                <DelayLink to="/iniciativa/agenda-de-sustentabilidade-avanca-com-pauta-ambiciosa">Agenda de sustentabilidade avança com pauta ambiciosa</DelayLink>.
                              </p>
                            </div>
                            <div className="col-3">
                              <p>
                                <img src={images.iniciativas.card5.img2} />
                                <br />
                                <b className="yellow">Inovação</b>
                                <br />
                                Também reformatado, o grupo reestruturou a agenda para 2021, com frentes relacionadas a
                                aspectos regulatórios e aproximação com a comunidade de inovação.
                              </p>
                            </div>
                            <div className="col-5">
                              <p>
                                <img src={images.iniciativas.card5.img3} />
                                <br />
                                <b className="yellow">Cibersegurança</b>
                                <br />
                                Dono de uma agenda mais técnica, o grupo teve entre suas principais atividades em 2020 a
                                condução da 3ª Pesquisa ANBIMA de Cibersegurança, que monitora a evolução das
                                instituições financeiras em relação às práticas de segurança cibernética. Pela primeira
                                vez, o levantamento ouviu instituições que seguem nossos códigos de autorregulação, mas
                                que não são associadas. Outra novidade foram perguntas para entender como a pandemia
                                impactou aspectos relacionados à cibersegurança. Os resultados da pesquisa serão
                                divulgados em 2021 e subsidiarão a revisão do guia de boas práticas da ANBIMA.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { Card5 };
